import React, { useEffect } from 'react';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import CheckIcon from '@material-ui/icons/Check';

function LotModel({
	formItem,
	documentPath,
	totalAutoFillInfo,
	select,
	setSelect,
	handleSelect,
}) {
	return (
		<div className='model_selection_wrapper'>
			{totalAutoFillInfo?.map((info, idx) => {
				return (
					<div
						className='label_wrapper_extra'
						data-id={idx}
						data-name='modelHomes'
						onClick={(e) => {
							console.log('infooo: ' + JSON.stringify(info));
							handleSelect(e, info);
							console.log(select + ' ' + idx);
						}}
					>
						<div className='lot_modelhomes_container'>
							<div
								className={
									select == idx
										? `lot_single_card building_active`
										: `lot_single_card ${idx} ${select}`
								}
							>
								<p className='lot_single_title'>{info?.name}</p>
								<small className='lot_single_sqft'>
									<span className='lot_availability'>
										<FiberManualRecordIcon className='available' />
									</span>
									$ {info.buildingPrice} / {info.sqft} SQFT
								</small>
								<CheckIcon
									className={`${
										select == idx ? `checkmark checkmark_active` : `checkmark`
									}`}
								/>
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
}

export default LotModel;
